import '@rammetec/design-system/styles.css'
import './styles.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { installStaleBuildRecovery } from '@rammetec/app-kit/errors'
import './services/i18n.bootstrap'
import { App } from '@/app/App'
import { STALE_BUILD_OPTIONS } from '@/shared/errors/staleBuildOptions'

installStaleBuildRecovery(STALE_BUILD_OPTIONS)

const root = document.getElementById('root')
if (!root) throw new Error('Root element #root was not found.')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
